import { useMemo } from "react";
import {
  BANK_ACCOUNT_NUMBER_MIN_MAX,
  IMPOUND_ACC_IS_REQUIRED,
  PAYEE_DISB_DESCRIPTION_MAX,
  WRONG_FORMAT_BANK_TRANSIT_ROUTING
} from "../../../../../../../../../../../lib/constants";
import { Rule } from "antd/es/form";

export const useRules = (method?: number) => {
  const required: boolean = useMemo(() => (method ? [5, 6].includes(method) : false), [method]);

  const bankAccountNumberRule: Rule[] = useMemo(
    () => [
      {
        min: 4,
        message: BANK_ACCOUNT_NUMBER_MIN_MAX,
        validateTrigger: "onSubmit"
      },
      {
        max: 17,
        message: BANK_ACCOUNT_NUMBER_MIN_MAX,
        validateTrigger: "onSubmit"
      },
      {
        required,
        validateTrigger: "onSubmit"
      }
    ],
    [required]
  );

  const bankTransitNumberRule: Rule[] = useMemo(
    () => [
      {
        validateTrigger: "onSubmit",
        validator(_: Rule, value: string) {
          if (required && !value) {
            return Promise.reject(new Error("Please enter Routing Number"));
          }

          if (!value || /^\d{9}$/.test(value)) {
            return Promise.resolve();
          }

          return Promise.reject(new Error(WRONG_FORMAT_BANK_TRANSIT_ROUTING));
        }
      }
    ],
    [required]
  );

  const impoundAccountRule = useMemo(
    () => [
      ({ getFieldValue }: any) => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: any) {
          if (getFieldValue("type") === 2 && !value) {
            return Promise.reject(new Error(IMPOUND_ACC_IS_REQUIRED));
          }
          return Promise.resolve();
        }
      })
    ],
    []
  );

  const descriptionRule: Rule[] = useMemo(
    () => [
      {
        max: 200,
        message: PAYEE_DISB_DESCRIPTION_MAX,
        validateTrigger: "onSubmit"
      }
    ],
    []
  );

  return {
    bankAccountNumberRule,
    bankTransitNumberRule,
    impoundAccountRule,
    descriptionRule
  };
};
